
let dev_mode = false;

let config = {
    dev_mode: dev_mode,
    phone: "1300 222 266",
    phone_compact: "1300222266",
    recaptcha_site_key: "6LcZ9NclAAAAAHiU5UtociIUJu7BHr_v1TKJUGeh",
    maps_api_key: "AIzaSyAG0cNYGOXO8qMF55jRowfgwk1GDagvgRY" //Server
    //maps_api_key: "AIzaSyDax_SaGNJEfl3e6cq1XLgIMvZUB3VUBiQ" //Client
};

export default config;